const countries = [
  {
    iso2: "4",
    alpha_2_code: "AF",
    alpha_3_code: "AFG",
    name: "Afghanistan",
    nationality: "Afghan",
  },
  {
    iso2: "248",
    alpha_2_code: "AX",
    alpha_3_code: "ALA",
    name: "\u00c5land Islands",
    nationality: "\u00c5land Island",
  },
  {
    iso2: "8",
    alpha_2_code: "AL",
    alpha_3_code: "ALB",
    name: "Albania",
    nationality: "Albanian",
  },
  {
    iso2: "12",
    alpha_2_code: "DZ",
    alpha_3_code: "DZA",
    name: "Algeria",
    nationality: "Algerian",
  },
  {
    iso2: "16",
    alpha_2_code: "AS",
    alpha_3_code: "ASM",
    name: "American Samoa",
    nationality: "American Samoan",
  },
  {
    iso2: "20",
    alpha_2_code: "AD",
    alpha_3_code: "AND",
    name: "Andorra",
    nationality: "Andorran",
  },
  {
    iso2: "24",
    alpha_2_code: "AO",
    alpha_3_code: "AGO",
    name: "Angola",
    nationality: "Angolan",
  },
  {
    iso2: "660",
    alpha_2_code: "AI",
    alpha_3_code: "AIA",
    name: "Anguilla",
    nationality: "Anguillan",
  },
  {
    iso2: "10",
    alpha_2_code: "AQ",
    alpha_3_code: "ATA",
    name: "Antarctica",
    nationality: "Antarctic",
  },
  {
    iso2: "28",
    alpha_2_code: "AG",
    alpha_3_code: "ATG",
    name: "Antigua and Barbuda",
    nationality: "Antiguan or Barbudan",
  },
  {
    iso2: "32",
    alpha_2_code: "AR",
    alpha_3_code: "ARG",
    name: "Argentina",
    nationality: "Argentine",
  },
  {
    iso2: "51",
    alpha_2_code: "AM",
    alpha_3_code: "ARM",
    name: "Armenia",
    nationality: "Armenian",
  },
  {
    iso2: "533",
    alpha_2_code: "AW",
    alpha_3_code: "ABW",
    name: "Aruba",
    nationality: "Aruban",
  },
  {
    iso2: "36",
    alpha_2_code: "AU",
    alpha_3_code: "AUS",
    name: "Australia",
    nationality: "Australian",
  },
  {
    iso2: "40",
    alpha_2_code: "AT",
    alpha_3_code: "AUT",
    name: "Austria",
    nationality: "Austrian",
  },
  {
    iso2: "31",
    alpha_2_code: "AZ",
    alpha_3_code: "AZE",
    name: "Azerbaijan",
    nationality: "Azerbaijani, Azeri",
  },
  {
    iso2: "44",
    alpha_2_code: "BS",
    alpha_3_code: "BHS",
    name: "Bahamas",
    nationality: "Bahamian",
  },
  {
    iso2: "48",
    alpha_2_code: "BH",
    alpha_3_code: "BHR",
    name: "Bahrain",
    nationality: "Bahraini",
  },
  {
    iso2: "50",
    alpha_2_code: "BD",
    alpha_3_code: "BGD",
    name: "Bangladesh",
    nationality: "Bangladeshi",
  },
  {
    iso2: "52",
    alpha_2_code: "BB",
    alpha_3_code: "BRB",
    name: "Barbados",
    nationality: "Barbadian",
  },
  {
    iso2: "112",
    alpha_2_code: "BY",
    alpha_3_code: "BLR",
    name: "Belarus",
    nationality: "Belarusian",
  },
  {
    iso2: "56",
    alpha_2_code: "BE",
    alpha_3_code: "BEL",
    name: "Belgium",
    nationality: "Belgian",
  },
  {
    iso2: "84",
    alpha_2_code: "BZ",
    alpha_3_code: "BLZ",
    name: "Belize",
    nationality: "Belizean",
  },
  {
    iso2: "204",
    alpha_2_code: "BJ",
    alpha_3_code: "BEN",
    name: "Benin",
    nationality: "Beninese, Beninois",
  },
  {
    iso2: "60",
    alpha_2_code: "BM",
    alpha_3_code: "BMU",
    name: "Bermuda",
    nationality: "Bermudian, Bermudan",
  },
  {
    iso2: "64",
    alpha_2_code: "BT",
    alpha_3_code: "BTN",
    name: "Bhutan",
    nationality: "Bhutanese",
  },
  {
    iso2: "68",
    alpha_2_code: "BO",
    alpha_3_code: "BOL",
    name: "Bolivia (Plurinational State of)",
    nationality: "Bolivian",
  },
  {
    iso2: "535",
    alpha_2_code: "BQ",
    alpha_3_code: "BES",
    name: "Bonaire, Sint Eustatius and Saba",
    nationality: "Bonaire",
  },
  {
    iso2: "70",
    alpha_2_code: "BA",
    alpha_3_code: "BIH",
    name: "Bosnia and Herzegovina",
    nationality: "Bosnian or Herzegovinian",
  },
  {
    iso2: "72",
    alpha_2_code: "BW",
    alpha_3_code: "BWA",
    name: "Botswana",
    nationality: "Motswana, Botswanan",
  },
  {
    iso2: "74",
    alpha_2_code: "BV",
    alpha_3_code: "BVT",
    name: "Bouvet Island",
    nationality: "Bouvet Island",
  },
  {
    iso2: "76",
    alpha_2_code: "BR",
    alpha_3_code: "BRA",
    name: "Brazil",
    nationality: "Brazilian",
  },
  {
    iso2: "86",
    alpha_2_code: "IO",
    alpha_3_code: "IOT",
    name: "British Indian Ocean Territory",
    nationality: "BIOT",
  },
  {
    iso2: "96",
    alpha_2_code: "BN",
    alpha_3_code: "BRN",
    name: "Brunei Darussalam",
    nationality: "Bruneian",
  },
  {
    iso2: "100",
    alpha_2_code: "BG",
    alpha_3_code: "BGR",
    name: "Bulgaria",
    nationality: "Bulgarian",
  },
  {
    iso2: "854",
    alpha_2_code: "BF",
    alpha_3_code: "BFA",
    name: "Burkina Faso",
    nationality: "Burkinab\u00e9",
  },
  {
    iso2: "108",
    alpha_2_code: "BI",
    alpha_3_code: "BDI",
    name: "Burundi",
    nationality: "Burundian",
  },
  {
    iso2: "132",
    alpha_2_code: "CV",
    alpha_3_code: "CPV",
    name: "Cabo Verde",
    nationality: "Cabo Verdean",
  },
  {
    iso2: "116",
    alpha_2_code: "KH",
    alpha_3_code: "KHM",
    name: "Cambodia",
    nationality: "Cambodian",
  },
  {
    iso2: "120",
    alpha_2_code: "CM",
    alpha_3_code: "CMR",
    name: "Cameroon",
    nationality: "Cameroonian",
  },
  {
    iso2: "124",
    alpha_2_code: "CA",
    alpha_3_code: "CAN",
    name: "Canada",
    nationality: "Canadian",
  },
  {
    iso2: "136",
    alpha_2_code: "KY",
    alpha_3_code: "CYM",
    name: "Cayman Islands",
    nationality: "Caymanian",
  },
  {
    iso2: "140",
    alpha_2_code: "CF",
    alpha_3_code: "CAF",
    name: "Central African Republic",
    nationality: "Central African",
  },
  {
    iso2: "148",
    alpha_2_code: "TD",
    alpha_3_code: "TCD",
    name: "Chad",
    nationality: "Chadian",
  },
  {
    iso2: "152",
    alpha_2_code: "CL",
    alpha_3_code: "CHL",
    name: "Chile",
    nationality: "Chilean",
  },
  {
    iso2: "156",
    alpha_2_code: "CN",
    alpha_3_code: "CHN",
    name: "China",
    nationality: "Chinese",
  },
  {
    iso2: "162",
    alpha_2_code: "CX",
    alpha_3_code: "CXR",
    name: "Christmas Island",
    nationality: "Christmas Island",
  },
  {
    iso2: "166",
    alpha_2_code: "CC",
    alpha_3_code: "CCK",
    name: "Cocos (Keeling) Islands",
    nationality: "Cocos Island",
  },
  {
    iso2: "170",
    alpha_2_code: "CO",
    alpha_3_code: "COL",
    name: "Colombia",
    nationality: "Colombian",
  },
  {
    iso2: "174",
    alpha_2_code: "KM",
    alpha_3_code: "COM",
    name: "Comoros",
    nationality: "Comoran, Comorian",
  },
  {
    iso2: "178",
    alpha_2_code: "CG",
    alpha_3_code: "COG",
    name: "Congo (Republic of the)",
    nationality: "Congolese",
  },
  {
    iso2: "180",
    alpha_2_code: "CD",
    alpha_3_code: "COD",
    name: "Congo (Democratic Republic of the)",
    nationality: "Congolese",
  },
  {
    iso2: "184",
    alpha_2_code: "CK",
    alpha_3_code: "COK",
    name: "Cook Islands",
    nationality: "Cook Island",
  },
  {
    iso2: "188",
    alpha_2_code: "CR",
    alpha_3_code: "CRI",
    name: "Costa Rica",
    nationality: "Costa Rican",
  },
  {
    iso2: "384",
    alpha_2_code: "CI",
    alpha_3_code: "CIV",
    name: "C\u00f4te d'Ivoire",
    nationality: "Ivorian",
  },
  {
    iso2: "191",
    alpha_2_code: "HR",
    alpha_3_code: "HRV",
    name: "Croatia",
    nationality: "Croatian",
  },
  {
    iso2: "192",
    alpha_2_code: "CU",
    alpha_3_code: "CUB",
    name: "Cuba",
    nationality: "Cuban",
  },
  {
    iso2: "531",
    alpha_2_code: "CW",
    alpha_3_code: "CUW",
    name: "Cura\u00e7ao",
    nationality: "Cura\u00e7aoan",
  },
  {
    iso2: "196",
    alpha_2_code: "CY",
    alpha_3_code: "CYP",
    name: "Cyprus",
    nationality: "Cypriot",
  },
  {
    iso2: "203",
    alpha_2_code: "CZ",
    alpha_3_code: "CZE",
    name: "Czech Republic",
    nationality: "Czech",
  },
  {
    iso2: "208",
    alpha_2_code: "DK",
    alpha_3_code: "DNK",
    name: "Denmark",
    nationality: "Danish",
  },
  {
    iso2: "262",
    alpha_2_code: "DJ",
    alpha_3_code: "DJI",
    name: "Djibouti",
    nationality: "Djiboutian",
  },
  {
    iso2: "212",
    alpha_2_code: "DM",
    alpha_3_code: "DMA",
    name: "Dominica",
    nationality: "Dominican",
  },
  {
    iso2: "214",
    alpha_2_code: "DO",
    alpha_3_code: "DOM",
    name: "Dominican Republic",
    nationality: "Dominican",
  },
  {
    iso2: "218",
    alpha_2_code: "EC",
    alpha_3_code: "ECU",
    name: "Ecuador",
    nationality: "Ecuadorian",
  },
  {
    iso2: "818",
    alpha_2_code: "EG",
    alpha_3_code: "EGY",
    name: "Egypt",
    nationality: "Egyptian",
  },
  {
    iso2: "222",
    alpha_2_code: "SV",
    alpha_3_code: "SLV",
    name: "El Salvador",
    nationality: "Salvadoran",
  },
  {
    iso2: "226",
    alpha_2_code: "GQ",
    alpha_3_code: "GNQ",
    name: "Equatorial Guinea",
    nationality: "Equatorial Guinean, Equatoguinean",
  },
  {
    iso2: "232",
    alpha_2_code: "ER",
    alpha_3_code: "ERI",
    name: "Eritrea",
    nationality: "Eritrean",
  },
  {
    iso2: "233",
    alpha_2_code: "EE",
    alpha_3_code: "EST",
    name: "Estonia",
    nationality: "Estonian",
  },
  {
    iso2: "231",
    alpha_2_code: "ET",
    alpha_3_code: "ETH",
    name: "Ethiopia",
    nationality: "Ethiopian",
  },
  {
    iso2: "238",
    alpha_2_code: "FK",
    alpha_3_code: "FLK",
    name: "Falkland Islands (Malvinas)",
    nationality: "Falkland Island",
  },
  {
    iso2: "234",
    alpha_2_code: "FO",
    alpha_3_code: "FRO",
    name: "Faroe Islands",
    nationality: "Faroese",
  },
  {
    iso2: "242",
    alpha_2_code: "FJ",
    alpha_3_code: "FJI",
    name: "Fiji",
    nationality: "Fijian",
  },
  {
    iso2: "246",
    alpha_2_code: "FI",
    alpha_3_code: "FIN",
    name: "Finland",
    nationality: "Finnish",
  },
  {
    iso2: "250",
    alpha_2_code: "FR",
    alpha_3_code: "FRA",
    name: "France",
    nationality: "French",
  },
  {
    iso2: "254",
    alpha_2_code: "GF",
    alpha_3_code: "GUF",
    name: "French Guiana",
    nationality: "French Guianese",
  },
  {
    iso2: "258",
    alpha_2_code: "PF",
    alpha_3_code: "PYF",
    name: "French Polynesia",
    nationality: "French Polynesian",
  },
  {
    iso2: "260",
    alpha_2_code: "TF",
    alpha_3_code: "ATF",
    name: "French Southern Territories",
    nationality: "French Southern Territories",
  },
  {
    iso2: "266",
    alpha_2_code: "GA",
    alpha_3_code: "GAB",
    name: "Gabon",
    nationality: "Gabonese",
  },
  {
    iso2: "270",
    alpha_2_code: "GM",
    alpha_3_code: "GMB",
    name: "Gambia",
    nationality: "Gambian",
  },
  {
    iso2: "268",
    alpha_2_code: "GE",
    alpha_3_code: "GEO",
    name: "Georgia",
    nationality: "Georgian",
  },
  {
    iso2: "276",
    alpha_2_code: "DE",
    alpha_3_code: "DEU",
    name: "Germany",
    nationality: "German",
  },
  {
    iso2: "288",
    alpha_2_code: "GH",
    alpha_3_code: "GHA",
    name: "Ghana",
    nationality: "Ghanaian",
  },
  {
    iso2: "292",
    alpha_2_code: "GI",
    alpha_3_code: "GIB",
    name: "Gibraltar",
    nationality: "Gibraltar",
  },
  {
    iso2: "300",
    alpha_2_code: "GR",
    alpha_3_code: "GRC",
    name: "Greece",
    nationality: "Greek, Hellenic",
  },
  {
    iso2: "304",
    alpha_2_code: "GL",
    alpha_3_code: "GRL",
    name: "Greenland",
    nationality: "Greenlandic",
  },
  {
    iso2: "308",
    alpha_2_code: "GD",
    alpha_3_code: "GRD",
    name: "Grenada",
    nationality: "Grenadian",
  },
  {
    iso2: "312",
    alpha_2_code: "GP",
    alpha_3_code: "GLP",
    name: "Guadeloupe",
    nationality: "Guadeloupe",
  },
  {
    iso2: "316",
    alpha_2_code: "GU",
    alpha_3_code: "GUM",
    name: "Guam",
    nationality: "Guamanian, Guambat",
  },
  {
    iso2: "320",
    alpha_2_code: "GT",
    alpha_3_code: "GTM",
    name: "Guatemala",
    nationality: "Guatemalan",
  },
  {
    iso2: "831",
    alpha_2_code: "GG",
    alpha_3_code: "GGY",
    name: "Guernsey",
    nationality: "Channel Island",
  },
  {
    iso2: "324",
    alpha_2_code: "GN",
    alpha_3_code: "GIN",
    name: "Guinea",
    nationality: "Guinean",
  },
  {
    iso2: "624",
    alpha_2_code: "GW",
    alpha_3_code: "GNB",
    name: "Guinea-Bissau",
    nationality: "Bissau-Guinean",
  },
  {
    iso2: "328",
    alpha_2_code: "GY",
    alpha_3_code: "GUY",
    name: "Guyana",
    nationality: "Guyanese",
  },
  {
    iso2: "332",
    alpha_2_code: "HT",
    alpha_3_code: "HTI",
    name: "Haiti",
    nationality: "Haitian",
  },
  {
    iso2: "334",
    alpha_2_code: "HM",
    alpha_3_code: "HMD",
    name: "Heard Island and McDonald Islands",
    nationality: "Heard Island or McDonald Islands",
  },
  {
    iso2: "336",
    alpha_2_code: "VA",
    alpha_3_code: "VAT",
    name: "Vatican City State",
    nationality: "Vatican",
  },
  {
    iso2: "340",
    alpha_2_code: "HN",
    alpha_3_code: "HND",
    name: "Honduras",
    nationality: "Honduran",
  },
  {
    iso2: "344",
    alpha_2_code: "HK",
    alpha_3_code: "HKG",
    name: "Hong Kong",
    nationality: "Hong Kong, Hong Kongese",
  },
  {
    iso2: "348",
    alpha_2_code: "HU",
    alpha_3_code: "HUN",
    name: "Hungary",
    nationality: "Hungarian, Magyar",
  },
  {
    iso2: "352",
    alpha_2_code: "IS",
    alpha_3_code: "ISL",
    name: "Iceland",
    nationality: "Icelandic",
  },
  {
    iso2: "356",
    alpha_2_code: "IN",
    alpha_3_code: "IND",
    name: "India",
    nationality: "Indian",
  },
  {
    iso2: "360",
    alpha_2_code: "ID",
    alpha_3_code: "IDN",
    name: "Indonesia",
    nationality: "Indonesian",
  },
  {
    iso2: "364",
    alpha_2_code: "IR",
    alpha_3_code: "IRN",
    name: "Iran",
    nationality: "Iranian, Persian",
  },
  {
    iso2: "368",
    alpha_2_code: "IQ",
    alpha_3_code: "IRQ",
    name: "Iraq",
    nationality: "Iraqi",
  },
  {
    iso2: "372",
    alpha_2_code: "IE",
    alpha_3_code: "IRL",
    name: "Ireland",
    nationality: "Irish",
  },
  {
    iso2: "833",
    alpha_2_code: "IM",
    alpha_3_code: "IMN",
    name: "Isle of Man",
    nationality: "Manx",
  },
  {
    iso2: "376",
    alpha_2_code: "IL",
    alpha_3_code: "ISR",
    name: "Israel",
    nationality: "Israeli",
  },
  {
    iso2: "380",
    alpha_2_code: "IT",
    alpha_3_code: "ITA",
    name: "Italy",
    nationality: "Italian",
  },
  {
    iso2: "388",
    alpha_2_code: "JM",
    alpha_3_code: "JAM",
    name: "Jamaica",
    nationality: "Jamaican",
  },
  {
    iso2: "392",
    alpha_2_code: "JP",
    alpha_3_code: "JPN",
    name: "Japan",
    nationality: "Japanese",
  },
  {
    iso2: "832",
    alpha_2_code: "JE",
    alpha_3_code: "JEY",
    name: "Jersey",
    nationality: "Channel Island",
  },
  {
    iso2: "400",
    alpha_2_code: "JO",
    alpha_3_code: "JOR",
    name: "Jordan",
    nationality: "Jordanian",
  },
  {
    iso2: "398",
    alpha_2_code: "KZ",
    alpha_3_code: "KAZ",
    name: "Kazakhstan",
    nationality: "Kazakhstani, Kazakh",
  },
  {
    iso2: "404",
    alpha_2_code: "KE",
    alpha_3_code: "KEN",
    name: "Kenya",
    nationality: "Kenyan",
  },
  {
    iso2: "296",
    alpha_2_code: "KI",
    alpha_3_code: "KIR",
    name: "Kiribati",
    nationality: "I-Kiribati",
  },
  {
    iso2: "408",
    alpha_2_code: "KP",
    alpha_3_code: "PRK",
    name: "Korea (Democratic People's Republic of)",
    nationality: "North Korean",
  },
  {
    iso2: "410",
    alpha_2_code: "KR",
    alpha_3_code: "KOR",
    name: "Korea (Republic of)",
    nationality: "South Korean",
  },
  {
    iso2: "414",
    alpha_2_code: "KW",
    alpha_3_code: "KWT",
    name: "Kuwait",
    nationality: "Kuwaiti",
  },
  {
    iso2: "417",
    alpha_2_code: "KG",
    alpha_3_code: "KGZ",
    name: "Kyrgyzstan",
    nationality: "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz",
  },
  {
    iso2: "418",
    alpha_2_code: "LA",
    alpha_3_code: "LAO",
    name: "Lao People's Democratic Republic",
    nationality: "Lao, Laotian",
  },
  {
    iso2: "428",
    alpha_2_code: "LV",
    alpha_3_code: "LVA",
    name: "Latvia",
    nationality: "Latvian",
  },
  {
    iso2: "422",
    alpha_2_code: "LB",
    alpha_3_code: "LBN",
    name: "Lebanon",
    nationality: "Lebanese",
  },
  {
    iso2: "426",
    alpha_2_code: "LS",
    alpha_3_code: "LSO",
    name: "Lesotho",
    nationality: "Basotho",
  },
  {
    iso2: "430",
    alpha_2_code: "LR",
    alpha_3_code: "LBR",
    name: "Liberia",
    nationality: "Liberian",
  },
  {
    iso2: "434",
    alpha_2_code: "LY",
    alpha_3_code: "LBY",
    name: "Libya",
    nationality: "Libyan",
  },
  {
    iso2: "438",
    alpha_2_code: "LI",
    alpha_3_code: "LIE",
    name: "Liechtenstein",
    nationality: "Liechtenstein",
  },
  {
    iso2: "440",
    alpha_2_code: "LT",
    alpha_3_code: "LTU",
    name: "Lithuania",
    nationality: "Lithuanian",
  },
  {
    iso2: "442",
    alpha_2_code: "LU",
    alpha_3_code: "LUX",
    name: "Luxembourg",
    nationality: "Luxembourg, Luxembourgish",
  },
  {
    iso2: "446",
    alpha_2_code: "MO",
    alpha_3_code: "MAC",
    name: "Macao",
    nationality: "Macanese, Chinese",
  },
  {
    iso2: "807",
    alpha_2_code: "MK",
    alpha_3_code: "MKD",
    name: "Macedonia (the former Yugoslav Republic of)",
    nationality: "Macedonian",
  },
  {
    iso2: "450",
    alpha_2_code: "MG",
    alpha_3_code: "MDG",
    name: "Madagascar",
    nationality: "Malagasy",
  },
  {
    iso2: "454",
    alpha_2_code: "MW",
    alpha_3_code: "MWI",
    name: "Malawi",
    nationality: "Malawian",
  },
  {
    iso2: "458",
    alpha_2_code: "MY",
    alpha_3_code: "MYS",
    name: "Malaysia",
    nationality: "Malaysian",
  },
  {
    iso2: "462",
    alpha_2_code: "MV",
    alpha_3_code: "MDV",
    name: "Maldives",
    nationality: "Maldivian",
  },
  {
    iso2: "466",
    alpha_2_code: "ML",
    alpha_3_code: "MLI",
    name: "Mali",
    nationality: "Malian, Malinese",
  },
  {
    iso2: "470",
    alpha_2_code: "MT",
    alpha_3_code: "MLT",
    name: "Malta",
    nationality: "Maltese",
  },
  {
    iso2: "584",
    alpha_2_code: "MH",
    alpha_3_code: "MHL",
    name: "Marshall Islands",
    nationality: "Marshallese",
  },
  {
    iso2: "474",
    alpha_2_code: "MQ",
    alpha_3_code: "MTQ",
    name: "Martinique",
    nationality: "Martiniquais, Martinican",
  },
  {
    iso2: "478",
    alpha_2_code: "MR",
    alpha_3_code: "MRT",
    name: "Mauritania",
    nationality: "Mauritanian",
  },
  {
    iso2: "480",
    alpha_2_code: "MU",
    alpha_3_code: "MUS",
    name: "Mauritius",
    nationality: "Mauritian",
  },
  {
    iso2: "175",
    alpha_2_code: "YT",
    alpha_3_code: "MYT",
    name: "Mayotte",
    nationality: "Mahoran",
  },
  {
    iso2: "484",
    alpha_2_code: "MX",
    alpha_3_code: "MEX",
    name: "Mexico",
    nationality: "Mexican",
  },
  {
    iso2: "583",
    alpha_2_code: "FM",
    alpha_3_code: "FSM",
    name: "Micronesia (Federated States of)",
    nationality: "Micronesian",
  },
  {
    iso2: "498",
    alpha_2_code: "MD",
    alpha_3_code: "MDA",
    name: "Moldova (Republic of)",
    nationality: "Moldovan",
  },
  {
    iso2: "492",
    alpha_2_code: "MC",
    alpha_3_code: "MCO",
    name: "Monaco",
    nationality: "Mon\u00e9gasque, Monacan",
  },
  {
    iso2: "496",
    alpha_2_code: "MN",
    alpha_3_code: "MNG",
    name: "Mongolia",
    nationality: "Mongolian",
  },
  {
    iso2: "499",
    alpha_2_code: "ME",
    alpha_3_code: "MNE",
    name: "Montenegro",
    nationality: "Montenegrin",
  },
  {
    iso2: "500",
    alpha_2_code: "MS",
    alpha_3_code: "MSR",
    name: "Montserrat",
    nationality: "Montserratian",
  },
  {
    iso2: "504",
    alpha_2_code: "MA",
    alpha_3_code: "MAR",
    name: "Morocco",
    nationality: "Moroccan",
  },
  {
    iso2: "508",
    alpha_2_code: "MZ",
    alpha_3_code: "MOZ",
    name: "Mozambique",
    nationality: "Mozambican",
  },
  {
    iso2: "104",
    alpha_2_code: "MM",
    alpha_3_code: "MMR",
    name: "Myanmar",
    nationality: "Burmese",
  },
  {
    iso2: "516",
    alpha_2_code: "NA",
    alpha_3_code: "NAM",
    name: "Namibia",
    nationality: "Namibian",
  },
  {
    iso2: "520",
    alpha_2_code: "NR",
    alpha_3_code: "NRU",
    name: "Nauru",
    nationality: "Nauruan",
  },
  {
    iso2: "524",
    alpha_2_code: "NP",
    alpha_3_code: "NPL",
    name: "Nepal",
    nationality: "Nepali, Nepalese",
  },
  {
    iso2: "528",
    alpha_2_code: "NL",
    alpha_3_code: "NLD",
    name: "Netherlands",
    nationality: "Dutch, Netherlandic",
  },
  {
    iso2: "540",
    alpha_2_code: "NC",
    alpha_3_code: "NCL",
    name: "New Caledonia",
    nationality: "New Caledonian",
  },
  {
    iso2: "554",
    alpha_2_code: "NZ",
    alpha_3_code: "NZL",
    name: "New Zealand",
    nationality: "New Zealand, NZ",
  },
  {
    iso2: "558",
    alpha_2_code: "NI",
    alpha_3_code: "NIC",
    name: "Nicaragua",
    nationality: "Nicaraguan",
  },
  {
    iso2: "562",
    alpha_2_code: "NE",
    alpha_3_code: "NER",
    name: "Niger",
    nationality: "Nigerien",
  },
  {
    iso2: "566",
    alpha_2_code: "NG",
    alpha_3_code: "NGA",
    name: "Nigeria",
    nationality: "Nigerian",
  },
  {
    iso2: "570",
    alpha_2_code: "NU",
    alpha_3_code: "NIU",
    name: "Niue",
    nationality: "Niuean",
  },
  {
    iso2: "574",
    alpha_2_code: "NF",
    alpha_3_code: "NFK",
    name: "Norfolk Island",
    nationality: "Norfolk Island",
  },
  {
    iso2: "580",
    alpha_2_code: "MP",
    alpha_3_code: "MNP",
    name: "Northern Mariana Islands",
    nationality: "Northern Marianan",
  },
  {
    iso2: "578",
    alpha_2_code: "NO",
    alpha_3_code: "NOR",
    name: "Norway",
    nationality: "Norwegian",
  },
  {
    iso2: "512",
    alpha_2_code: "OM",
    alpha_3_code: "OMN",
    name: "Oman",
    nationality: "Omani",
  },
  {
    iso2: "586",
    alpha_2_code: "PK",
    alpha_3_code: "PAK",
    name: "Pakistan",
    nationality: "Pakistani",
  },
  {
    iso2: "585",
    alpha_2_code: "PW",
    alpha_3_code: "PLW",
    name: "Palau",
    nationality: "Palauan",
  },
  {
    iso2: "275",
    alpha_2_code: "PS",
    alpha_3_code: "PSE",
    name: "Palestine, State of",
    nationality: "Palestinian",
  },
  {
    iso2: "591",
    alpha_2_code: "PA",
    alpha_3_code: "PAN",
    name: "Panama",
    nationality: "Panamanian",
  },
  {
    iso2: "598",
    alpha_2_code: "PG",
    alpha_3_code: "PNG",
    name: "Papua New Guinea",
    nationality: "Papua New Guinean, Papuan",
  },
  {
    iso2: "600",
    alpha_2_code: "PY",
    alpha_3_code: "PRY",
    name: "Paraguay",
    nationality: "Paraguayan",
  },
  {
    iso2: "604",
    alpha_2_code: "PE",
    alpha_3_code: "PER",
    name: "Peru",
    nationality: "Peruvian",
  },
  {
    iso2: "608",
    alpha_2_code: "PH",
    alpha_3_code: "PHL",
    name: "Philippines",
    nationality: "Philippine, Filipino",
  },
  {
    iso2: "612",
    alpha_2_code: "PN",
    alpha_3_code: "PCN",
    name: "Pitcairn",
    nationality: "Pitcairn Island",
  },
  {
    iso2: "616",
    alpha_2_code: "PL",
    alpha_3_code: "POL",
    name: "Poland",
    nationality: "Polish",
  },
  {
    iso2: "620",
    alpha_2_code: "PT",
    alpha_3_code: "PRT",
    name: "Portugal",
    nationality: "Portuguese",
  },
  {
    iso2: "630",
    alpha_2_code: "PR",
    alpha_3_code: "PRI",
    name: "Puerto Rico",
    nationality: "Puerto Rican",
  },
  {
    iso2: "634",
    alpha_2_code: "QA",
    alpha_3_code: "QAT",
    name: "Qatar",
    nationality: "Qatari",
  },
  {
    iso2: "638",
    alpha_2_code: "RE",
    alpha_3_code: "REU",
    name: "R\u00e9union",
    nationality: "R\u00e9unionese, R\u00e9unionnais",
  },
  {
    iso2: "642",
    alpha_2_code: "RO",
    alpha_3_code: "ROU",
    name: "Romania",
    nationality: "Romanian",
  },
  {
    iso2: "643",
    alpha_2_code: "RU",
    alpha_3_code: "RUS",
    name: "Russian Federation",
    nationality: "Russian",
  },
  {
    iso2: "646",
    alpha_2_code: "RW",
    alpha_3_code: "RWA",
    name: "Rwanda",
    nationality: "Rwandan",
  },
  {
    iso2: "652",
    alpha_2_code: "BL",
    alpha_3_code: "BLM",
    name: "Saint Barth\u00e9lemy",
    nationality: "Barth\u00e9lemois",
  },
  {
    iso2: "654",
    alpha_2_code: "SH",
    alpha_3_code: "SHN",
    name: "Saint Helena, Ascension and Tristan da Cunha",
    nationality: "Saint Helenian",
  },
  {
    iso2: "659",
    alpha_2_code: "KN",
    alpha_3_code: "KNA",
    name: "Saint Kitts and Nevis",
    nationality: "Kittitian or Nevisian",
  },
  {
    iso2: "662",
    alpha_2_code: "LC",
    alpha_3_code: "LCA",
    name: "Saint Lucia",
    nationality: "Saint Lucian",
  },
  {
    iso2: "663",
    alpha_2_code: "MF",
    alpha_3_code: "MAF",
    name: "Saint Martin (French part)",
    nationality: "Saint-Martinoise",
  },
  {
    iso2: "666",
    alpha_2_code: "PM",
    alpha_3_code: "SPM",
    name: "Saint Pierre and Miquelon",
    nationality: "Saint-Pierrais or Miquelonnais",
  },
  {
    iso2: "670",
    alpha_2_code: "VC",
    alpha_3_code: "VCT",
    name: "Saint Vincent and the Grenadines",
    nationality: "Saint Vincentian, Vincentian",
  },
  {
    iso2: "882",
    alpha_2_code: "WS",
    alpha_3_code: "WSM",
    name: "Samoa",
    nationality: "Samoan",
  },
  {
    iso2: "674",
    alpha_2_code: "SM",
    alpha_3_code: "SMR",
    name: "San Marino",
    nationality: "Sammarinese",
  },
  {
    iso2: "678",
    alpha_2_code: "ST",
    alpha_3_code: "STP",
    name: "Sao Tome and Principe",
    nationality: "S\u00e3o Tom\u00e9an",
  },
  {
    iso2: "682",
    alpha_2_code: "SA",
    alpha_3_code: "SAU",
    name: "Saudi Arabia",
    nationality: "Saudi, Saudi Arabian",
  },
  {
    iso2: "686",
    alpha_2_code: "SN",
    alpha_3_code: "SEN",
    name: "Senegal",
    nationality: "Senegalese",
  },
  {
    iso2: "688",
    alpha_2_code: "RS",
    alpha_3_code: "SRB",
    name: "Serbia",
    nationality: "Serbian",
  },
  {
    iso2: "690",
    alpha_2_code: "SC",
    alpha_3_code: "SYC",
    name: "Seychelles",
    nationality: "Seychellois",
  },
  {
    iso2: "694",
    alpha_2_code: "SL",
    alpha_3_code: "SLE",
    name: "Sierra Leone",
    nationality: "Sierra Leonean",
  },
  {
    iso2: "702",
    alpha_2_code: "SG",
    alpha_3_code: "SGP",
    name: "Singapore",
    nationality: "Singaporean",
  },
  {
    iso2: "534",
    alpha_2_code: "SX",
    alpha_3_code: "SXM",
    name: "Sint Maarten (Dutch part)",
    nationality: "Sint Maarten",
  },
  {
    iso2: "703",
    alpha_2_code: "SK",
    alpha_3_code: "SVK",
    name: "Slovakia",
    nationality: "Slovak",
  },
  {
    iso2: "705",
    alpha_2_code: "SI",
    alpha_3_code: "SVN",
    name: "Slovenia",
    nationality: "Slovenian, Slovene",
  },
  {
    iso2: "90",
    alpha_2_code: "SB",
    alpha_3_code: "SLB",
    name: "Solomon Islands",
    nationality: "Solomon Island",
  },
  {
    iso2: "706",
    alpha_2_code: "SO",
    alpha_3_code: "SOM",
    name: "Somalia",
    nationality: "Somali, Somalian",
  },
  {
    iso2: "710",
    alpha_2_code: "ZA",
    alpha_3_code: "ZAF",
    name: "South Africa",
    nationality: "South African",
  },
  {
    iso2: "239",
    alpha_2_code: "GS",
    alpha_3_code: "SGS",
    name: "South Georgia and the South Sandwich Islands",
    nationality: "South Georgia or South Sandwich Islands",
  },
  {
    iso2: "728",
    alpha_2_code: "SS",
    alpha_3_code: "SSD",
    name: "South Sudan",
    nationality: "South Sudanese",
  },
  {
    iso2: "724",
    alpha_2_code: "ES",
    alpha_3_code: "ESP",
    name: "Spain",
    nationality: "Spanish",
  },
  {
    iso2: "144",
    alpha_2_code: "LK",
    alpha_3_code: "LKA",
    name: "Sri Lanka",
    nationality: "Sri Lankan",
  },
  {
    iso2: "729",
    alpha_2_code: "SD",
    alpha_3_code: "SDN",
    name: "Sudan",
    nationality: "Sudanese",
  },
  {
    iso2: "740",
    alpha_2_code: "SR",
    alpha_3_code: "SUR",
    name: "Suriname",
    nationality: "Surinamese",
  },
  {
    iso2: "744",
    alpha_2_code: "SJ",
    alpha_3_code: "SJM",
    name: "Svalbard and Jan Mayen",
    nationality: "Svalbard",
  },
  {
    iso2: "748",
    alpha_2_code: "SZ",
    alpha_3_code: "SWZ",
    name: "Swaziland",
    nationality: "Swazi",
  },
  {
    iso2: "752",
    alpha_2_code: "SE",
    alpha_3_code: "SWE",
    name: "Sweden",
    nationality: "Swedish",
  },
  {
    iso2: "756",
    alpha_2_code: "CH",
    alpha_3_code: "CHE",
    name: "Switzerland",
    nationality: "Swiss",
  },
  {
    iso2: "760",
    alpha_2_code: "SY",
    alpha_3_code: "SYR",
    name: "Syrian Arab Republic",
    nationality: "Syrian",
  },
  {
    iso2: "158",
    alpha_2_code: "TW",
    alpha_3_code: "TWN",
    name: "Taiwan, Province of China",
    nationality: "Chinese, Taiwanese",
  },
  {
    iso2: "762",
    alpha_2_code: "TJ",
    alpha_3_code: "TJK",
    name: "Tajikistan",
    nationality: "Tajikistani",
  },
  {
    iso2: "834",
    alpha_2_code: "TZ",
    alpha_3_code: "TZA",
    name: "Tanzania, United Republic of",
    nationality: "Tanzanian",
  },
  {
    iso2: "764",
    alpha_2_code: "TH",
    alpha_3_code: "THA",
    name: "Thailand",
    nationality: "Thai",
  },
  {
    iso2: "626",
    alpha_2_code: "TL",
    alpha_3_code: "TLS",
    name: "Timor-Leste",
    nationality: "Timorese",
  },
  {
    iso2: "768",
    alpha_2_code: "TG",
    alpha_3_code: "TGO",
    name: "Togo",
    nationality: "Togolese",
  },
  {
    iso2: "772",
    alpha_2_code: "TK",
    alpha_3_code: "TKL",
    name: "Tokelau",
    nationality: "Tokelauan",
  },
  {
    iso2: "776",
    alpha_2_code: "TO",
    alpha_3_code: "TON",
    name: "Tonga",
    nationality: "Tongan",
  },
  {
    iso2: "780",
    alpha_2_code: "TT",
    alpha_3_code: "TTO",
    name: "Trinidad and Tobago",
    nationality: "Trinidadian or Tobagonian",
  },
  {
    iso2: "788",
    alpha_2_code: "TN",
    alpha_3_code: "TUN",
    name: "Tunisia",
    nationality: "Tunisian",
  },
  {
    iso2: "792",
    alpha_2_code: "TR",
    alpha_3_code: "TUR",
    name: "Turkey",
    nationality: "Turkish",
  },
  {
    iso2: "795",
    alpha_2_code: "TM",
    alpha_3_code: "TKM",
    name: "Turkmenistan",
    nationality: "Turkmen",
  },
  {
    iso2: "796",
    alpha_2_code: "TC",
    alpha_3_code: "TCA",
    name: "Turks and Caicos Islands",
    nationality: "Turks and Caicos Island",
  },
  {
    iso2: "798",
    alpha_2_code: "TV",
    alpha_3_code: "TUV",
    name: "Tuvalu",
    nationality: "Tuvaluan",
  },
  {
    iso2: "800",
    alpha_2_code: "UG",
    alpha_3_code: "UGA",
    name: "Uganda",
    nationality: "Ugandan",
  },
  {
    iso2: "804",
    alpha_2_code: "UA",
    alpha_3_code: "UKR",
    name: "Ukraine",
    nationality: "Ukrainian",
  },
  {
    iso2: "784",
    alpha_2_code: "AE",
    alpha_3_code: "ARE",
    name: "United Arab Emirates",
    nationality: "Emirati, Emirian, Emiri",
  },
  {
    iso2: "826",
    alpha_2_code: "GB",
    alpha_3_code: "GBR",
    name: "United Kingdom of Great Britain and Northern Ireland",
    nationality: "British, UK",
  },
  {
    iso2: "581",
    alpha_2_code: "UM",
    alpha_3_code: "UMI",
    name: "United States Minor Outlying Islands",
    nationality: "American",
  },
  {
    iso2: "840",
    alpha_2_code: "US",
    alpha_3_code: "USA",
    name: "United States of America",
    nationality: "American",
  },
  {
    iso2: "858",
    alpha_2_code: "UY",
    alpha_3_code: "URY",
    name: "Uruguay",
    nationality: "Uruguayan",
  },
  {
    iso2: "860",
    alpha_2_code: "UZ",
    alpha_3_code: "UZB",
    name: "Uzbekistan",
    nationality: "Uzbekistani, Uzbek",
  },
  {
    iso2: "548",
    alpha_2_code: "VU",
    alpha_3_code: "VUT",
    name: "Vanuatu",
    nationality: "Ni-Vanuatu, Vanuatuan",
  },
  {
    iso2: "862",
    alpha_2_code: "VE",
    alpha_3_code: "VEN",
    name: "Venezuela (Bolivarian Republic of)",
    nationality: "Venezuelan",
  },
  {
    iso2: "704",
    alpha_2_code: "VN",
    alpha_3_code: "VNM",
    name: "Vietnam",
    nationality: "Vietnamese",
  },
  {
    iso2: "92",
    alpha_2_code: "VG",
    alpha_3_code: "VGB",
    name: "Virgin Islands (British)",
    nationality: "British Virgin Island",
  },
  {
    iso2: "850",
    alpha_2_code: "VI",
    alpha_3_code: "VIR",
    name: "Virgin Islands (U.S.)",
    nationality: "U.S. Virgin Island",
  },
  {
    iso2: "876",
    alpha_2_code: "WF",
    alpha_3_code: "WLF",
    name: "Wallis and Futuna",
    nationality: "Wallis and Futuna, Wallisian or Futunan",
  },
  {
    iso2: "732",
    alpha_2_code: "EH",
    alpha_3_code: "ESH",
    name: "Western Sahara",
    nationality: "Sahrawi, Sahrawian, Sahraouian",
  },
  {
    iso2: "887",
    alpha_2_code: "YE",
    alpha_3_code: "YEM",
    name: "Yemen",
    nationality: "Yemeni",
  },
  {
    iso2: "894",
    alpha_2_code: "ZM",
    alpha_3_code: "ZMB",
    name: "Zambia",
    nationality: "Zambian",
  },
  {
    iso2: "716",
    alpha_2_code: "ZW",
    alpha_3_code: "ZWE",
    name: "Zimbabwe",
    nationality: "Zimbabwean",
  },
];

export default countries;

export const nationalityOptions = () => {
  return countries?.map((option) => ({
    key: option.iso2,
    label: `${option.nationality} (${option.alpha_3_code})`,
    value: option.nationality,
  }));
};
export const countryNameByIso2 = (iso2) => {
  return countries.find((country) => country.iso2 === iso2).name;
};
